import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-small-loader',
    template: '<div class="small-loader"><div></div><div></div></div>',
    styles: [`
.small-loader {
  display: inline-block;
  position: relative;
  width: 1em;
  height: 1em;
  vertical-align: middle;
}
.small-loader div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1);
  border: 2px solid black;
  background: black;
  opacity: 1;
  width: 100%;
  height: 100%;
  border-radius: 0;
  animation: small-loader 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.small-loader div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes small-loader {
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0;
  }
}
    `]
})
export class SmallLoaderComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
